import{AllCalendarTypes as e}from"./CalendarSnippet.types.js";const p=p=>e.includes(p);export{p as isCalendarTypeSupported};
//# sourceMappingURL=CalendarSnippet.helpers.js.map
